import React, { useRef, useEffect } from 'react';
import renderIf from 'render-if';
import { useController } from '@aha-app/mvc';
import { view } from '@aha-app/react-easy-state';
import FredController from './controllers/FredController';
import SanitizeInnerHTML from 'components/SanitizeInnerHTML/SanitizeInnerHTML';

const newCache = () => {
  return {
    selectedRecord: null,
  };
};

let cache = newCache();
document.addEventListener('aha.fred.error', () => {
  cache = newCache();
});

const Result = ({
  result,
  timestampCopy,
  additionalOnclick = null,
  showProject = true,
}) => {
  const controller = useController(FredController);
  const anchorRef = useRef(null);

  const onClick = e => {
    e.preventDefault();
    e.stopPropagation();
    cache.selectedRecordUrl = result.url;

    if (additionalOnclick !== null) {
      additionalOnclick();
    }

    controller.actionSelectResult(result);

    return false;
  };

  // restore focus if reopened
  useEffect(() => {
    if (cache.selectedRecordUrl === result.url) {
      anchorRef.current.focus();
      cache.selectedRecordUrl = null;
    }
  }, [result]);

  return (
    <a className='result' onClick={onClick} href={result.url} ref={anchorRef}>
      <div className='result__preheader'>
        {renderIf(showProject && result.project_name)(() => {
          return (
            <>
              <div className='result__project'>{result.project_name}</div>
              <div className='result__preheader__divider'>|</div>
            </>
          );
        })}
        {renderIf(result.object_icon || result.searchable_reference_num)(() => {
          return (
            <>
              {renderIf(result.object_icon)(
                <>
                  <i className={result.object_icon} />
                  {renderIf(result.show_searchable_type)(
                    result.searchable_type_terminology
                  )}
                </>
              )}
              {renderIf(result.searchable_reference_num)(
                <span className='result__reference-num'>
                  {result.searchable_reference_num}
                </span>
              )}
            </>
          );
        })}
      </div>

      <div className='result__header'>
        <a className='result__header__name' onClick={onClick} href={result.url}>
          {result.searchable_name}
        </a>
        {renderIf(result.searchable_status)(() => {
          return (
            <div className='result__status'>
              <aha-pill
                color={result.searchable_status.background_color}
                size='small'
                type={result.searchable_status.outline_pill ? 'outline' : ''}
              >
                {result.searchable_status.text}
              </aha-pill>
            </div>
          );
        })}
      </div>
      <SanitizeInnerHTML html={result.excerpt} element={<div />} />
      <div className='result__timestamp'>
        {timestampCopy} {result.searchable_date}
      </div>
    </a>
  );
};

export default view(Result);
